<template>
  <div class="head">
    <div class="wzheader" @click="childMethod">
      <a href="javascript:;"><img style="width: 100%;display: block;" src="http://www.itcast.cn/images/phonelogo4.png"></a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      
    };
  },
  methods: {
    childMethod() {
      this.$parent.itcastClick();
    }
  }
};
</script>

<style lang="less" scoped>
.head {
  .wzheader {
    width: 100%;
    height: auto;
    padding: 3% 0;
    background: #eee;
    position: relative;
  }
  a {
    display: block;
    width: 55%;
    margin: 0 auto;
  }
}
</style>
